module.exports = __webpack_public_path__ + "img/5.521a6d67.jpg";